





































































import { Component, Vue } from "vue-property-decorator";
import ButtonComponent from "./ButtonComponent.vue";

@Component({
  components: {
    buttonComponent: ButtonComponent
  }
})
export default class PersonalDetailsComponent extends Vue {}
